export class DetalhamentoFaturaClienteLaudo {
  id: number;
  nomeLaudo: string;
  quantidade: string;
  valorUnitario: string;
  valorTotal: string;

  constructor(detalhamentoFaturaClienteConsulta) {
    this.id = detalhamentoFaturaClienteConsulta['id'] || null;
    this.nomeLaudo = detalhamentoFaturaClienteConsulta['nomeLaudo'] || null;
    this.quantidade = detalhamentoFaturaClienteConsulta['quantidade'] || null;
    this.valorUnitario = detalhamentoFaturaClienteConsulta['valorUnitario'] || null;
    this.valorTotal = detalhamentoFaturaClienteConsulta['valorTotal'] || null;
  }

}
